import { addressFormat } from './address-format';

export const GB = {
  validator: null,
  addressFormat,
};
